export default {
  name: 'advanced-workflow',
  translationKey: 'advance-workflow-module',
  routePrefix: 'workflow',
  routeNamePrefix: 'admin.advanced-workflow',
  directRoutesAvailable: false,
}
